<template>
  <div v-if="authReady">
    <router-view></router-view>
  </div>
</template>

<script>
/* REMOVE MASTERWORK'S USER SNAP Recording
const env = process.env.NODE_ENV
if (env !== 'production') {
  var s = document.createElement('script'); s.type = 'text/javascript'
  s.async = true
  s.src = '//api.usersnap.com/load/3560d8c0-f011-423d-abe8-3f679d76d867.js'
  var x = document.getElementsByTagName('script')[0]
  x.parentNode.insertBefore(s, x)
}
*/
// Toybox
const env = process.env.NODE_ENV
if (env !== 'production') {
  var s = document.createElement('script')
  s.type = 'text/javascript'
  s.async = true
  s.src = 'https://d16ahjtmf9d1au.cloudfront.net/inject.bundle.js'
  s.setAttribute('data-id', 'ToyboxSnippet')
  s.setAttribute('data-token', 'jh7ZGxgHPcQL')
  var x = document.getElementsByTagName('script')[0]
  x.parentNode.insertBefore(s, x)
}

export default {
  name: 'app',
  computed: {
    authReady: function () {
      return this.$auth.ready()
    }
  }
}
</script>

<style>
  /* Import Font Awesome Icons Set */
  @import '~flag-icon-css/css/flag-icon.min.css';
  /* Import Font Awesome Icons Set */
  /* $fa-font-path: '~font-awesome/fonts/'; */
  @import '~font-awesome/css/font-awesome.min.css';
  /* Import Simple Line Icons Set */
  /* $simple-line-font-path: '~simple-line-icons/fonts/'; */
  @import '~simple-line-icons/css/simple-line-icons.css';
  /* Import Bootstrap Vue Styles */
  @import '~bootstrap-vue/dist/bootstrap-vue.css';
</style>
<style lang="scss">
  // Import Main styles for this application
  @import './scss/style';
</style>



// WEBPACK FOOTER //
// src/App.vue